import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import moment from 'moment';

const initialState = {
    expiredServicesEvents: { count: 0, rows: [] },
    before: '',
    after: moment().subtract(1, 'months').toISOString(),
    loading: false,
    loadingBadge: false,
    expiredServicesFilter: {},
    // Filters
    filteredEquipmentModels: [],
    filteredEquipmentGroups: [],
    filteredPlaces: [],
    filteredServiceTypes: [],
    filteredFrequencies: [],
    filteredAreas: [],
    filteredCompanies: [],
    filterShowMandatoryServices: true,
    filterShowNonMandatoryServices: false,
    badge: 0
};

const setExpiredServicesFilter = (state, action) => {
  return updateObject(state, {
    expiredServicesFilter: action.expiredServicesFilter,
  });
};

const requestExpiredServicesBadgeStart = ( state, action ) => {
    return updateObject( state, { loadingBadge: true } );
};

const requestExpiredServicesStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const fetchExpiredServicesSuccess = ( state, action ) => {
    return updateObject( state, {
        expiredServicesEvents: action.expiredServicesEvents,
        before: action.before,
        after: action.after,
        loading: false
    } );
}; 

const requestExpiredServicesFail = ( state, action ) => {
  return updateObject( state, { loading: false } );
};

const fetchExpiredServicesBadgeSuccess = (state, action) => {
  return updateObject( state, {
    badge: action.badge,
    loadingBadge: false
  })
}

const requestExpiredServicesBadgeFail = ( state, action ) => {
  return updateObject( state, { loadingBadge: false } );
};

const filterExpiredServiceStartDate = (state, action) => {
  let after = action.startDate;
  return updateObject(state, { after });
}

const filterExpiredServiceStartDateRemove = (state, action) => {
  return updateObject(state, { after: null });
}

const filterExpiredServiceEndDate = (state, action) => {
  let before = action.endDate;
  return updateObject(state, { before });
}

const filterExpiredServiceEndDateRemove = (state, action) => {
  return updateObject(state, { before: null });
}

const filterExpiredServiceTypes = (state, action) => {
  return updateObject(state, { filteredServiceTypes: action.serviceTypes });
}

const filterExpiredServiceTypesRemove = (state, action) => {
	let arr = [...state.filteredServiceTypes];
	const filteredServiceTypes = arr.filter(serviceType => serviceType.value !== action.serviceType.value)
  return updateObject(state, { filteredServiceTypes });
}

const filterExpiredServicesEquipmentGroups = (state, action) => {
  return updateObject(state, { filteredEquipmentGroups: action.equipmentGroups });
}

const filterExpiredServicesEquipmentGroupsRemove = (state, action) => {
	let arr = [...state.filteredEquipmentGroups];
	const filteredEquipmentGroups = arr.filter(equipment => equipment.value !== action.equipmentGroup.value)
  return updateObject(state, { filteredEquipmentGroups });
}

const filterExpiredServicesPlaces = (state, action) => {
  return updateObject(state, { filteredPlaces: action.places });
}

const filterExpiredServicesPlacesRemove = (state, action) => {
	let arr = [...state.filteredPlaces];
	const filteredPlaces = arr.filter(equipment => equipment.value !== action.place.value)
  return updateObject(state, { filteredPlaces });
}

const filterExpiredServicesEquipmentModels = (state, action) => {
  return updateObject(state, { filteredEquipmentModels: action.equipmentModels });
}

const filterExpiredServicesEquipmentModelsRemove = (state, action) => {
	let arr = [...state.filteredEquipmentModels];
	const filteredEquipmentModels = arr.filter(equipment => equipment.value !== action.equipmentModel.value)
  return updateObject(state, { filteredEquipmentModels });
}

const filterExpiredServicesAreas = (state, action) => {
  return updateObject(state, { filteredAreas: action.areas });
}

const filterExpiredServicesAreasRemove = (state, action) => {
	let arr = [...state.filteredAreas];
	const filteredAreas = arr.filter(area => area.value !== action.area.value)
  return updateObject(state, { filteredAreas });
}

const filterExpiredServicesCompanies = (state, action) => {
  return updateObject(state, { filteredCompanies: action.companies });
}

const filterExpiredServicesCompaniesRemove = (state, action) => {
  let arr = [...state.filteredCompanies];
	const filteredCompanies = arr.filter(company => company.value !== action.company.value)
  return updateObject(state, { filteredCompanies });
}

const filterExpiredServicesFrequencies = (state, action) => {
  return updateObject(state, { filteredFrequencies: action.frequencies });
}

const filterExpiredServicesFrequenciesRemove = (state, action) => {
	let arr = [...state.filteredFrequencies];
	const filteredFrequencies = arr.filter(frequency => frequency.value !== action.frequency.value)
  return updateObject(state, { filteredFrequencies });
}

const filterExpiredServicesClear = (state, action) => {
  return updateObject(state, { filteredEquipmentModels: [], filteredEquipmentGroups: [], filteredServiceTypes: [], filteredFrequencies: [], filteredAreas: [], filteredCompanies: [], filteredPlaces: [], before: '', after: '', filterShowMandatoryServices: false, filterShowNonMandatoryServices: false });
}

const filterShowMandatoryServices = (state, action) => {
  return updateObject(state, { filterShowMandatoryServices: action.payload });
}

const filterShowNonMandatoryServices = (state, action) => {
  return updateObject(state, { filterShowNonMandatoryServices: action.payload });
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.SET_EXPIRED_SERVICES_FILTER: return setExpiredServicesFilter(state, action);
        case actionTypes.REQUEST_EXPIRED_SERVICE_BADGE_START: return requestExpiredServicesBadgeStart( state, action );
        case actionTypes.REQUEST_EXPIRED_SERVICE_START: return requestExpiredServicesStart( state, action );
        case actionTypes.FETCH_EXPIRED_SERVICE_SUCCESS: return fetchExpiredServicesSuccess( state, action );
        case actionTypes.REQUEST_EXPIRED_SERVICE_FAIL: return requestExpiredServicesFail( state, action );
        case actionTypes.FETCH_EXPIRED_SERVICES_BADGE_SUCCESS: return fetchExpiredServicesBadgeSuccess( state, action );
        case actionTypes.REQUEST_EXPIRED_SERVICE_BADGE_FAIL: return requestExpiredServicesBadgeFail( state, action );
        case actionTypes.FILTER_EXPIRED_SERVICE_START_DATE: return filterExpiredServiceStartDate(state, action);
        case actionTypes.FILTER_EXPIRED_SERVICE_START_DATE_REMOVE: return filterExpiredServiceStartDateRemove(state, action);
        case actionTypes.FILTER_EXPIRED_SERVICE_END_DATE: return filterExpiredServiceEndDate(state, action);
        case actionTypes.FILTER_EXPIRED_SERVICE_END_DATE_REMOVE: return filterExpiredServiceEndDateRemove(state, action);
        case actionTypes.FILTER_EXPIRED_SERVICE_TYPES: return filterExpiredServiceTypes(state, action);
        case actionTypes.FILTER_EXPIRED_SERVICE_TYPES_REMOVE: return filterExpiredServiceTypesRemove(state, action);
        case actionTypes.FILTER_EXPIRED_SERVICES_EQUIPMENT_GROUPS: return filterExpiredServicesEquipmentGroups( state, action );
        case actionTypes.FILTER_EXPIRED_SERVICES_EQUIPMENT_GROUPS_REMOVE: return filterExpiredServicesEquipmentGroupsRemove( state, action );
        case actionTypes.FILTER_EXPIRED_SERVICES_PLACES: return filterExpiredServicesPlaces( state, action );
        case actionTypes.FILTER_EXPIRED_SERVICES_PLACES_REMOVE: return filterExpiredServicesPlacesRemove( state, action );

        
        case actionTypes.FILTER_EXPIRED_SERVICES_MODELS: return filterExpiredServicesEquipmentModels( state, action );
        case actionTypes.FILTER_EXPIRED_SERVICES_MODELS_REMOVE: return filterExpiredServicesEquipmentModelsRemove( state, action );
        case actionTypes.FILTER_EXPIRED_SERVICES_AREAS: return filterExpiredServicesAreas( state, action );
        case actionTypes.FILTER_EXPIRED_SERVICES_AREAS_REMOVE: return filterExpiredServicesAreasRemove( state, action );
        case actionTypes.FILTER_EXPIRED_SERVICES_COMPANIES: return filterExpiredServicesCompanies( state, action );
        case actionTypes.FILTER_EXPIRED_SERVICES_COMPANIES_REMOVE: return filterExpiredServicesCompaniesRemove( state, action );
        case actionTypes.FILTER_EXPIRED_SERVICES_FREQUENCIES: return filterExpiredServicesFrequencies(state, action);
        case actionTypes.FILTER_EXPIRED_SERVICES_FREQUENCIES_REMOVE: return filterExpiredServicesFrequenciesRemove(state, action);
        case actionTypes.FILTER_EXPIRED_SERVICES_CLEAR: return filterExpiredServicesClear( state, action );
        case actionTypes.EXPIRED_SERVICES_FILTER_SHOW_MANDATORY_SERVICES: return filterShowMandatoryServices(state, action);
        case actionTypes.EXPIRED_SERVICES_FILTER_SHOW_NON_MANDATORY_SERVICES: return filterShowNonMandatoryServices(state, action);

        default: return state;
    }
};

export default reducer;
